export enum RouteStatus {
    Draft = 1,
    Assigned = 2,
    Ongoing = 3,
    Completed = 4
}
